/*
    Get map styles from https://snazzymaps.com/
    or write them yourself. that link is easier though.
*/

const mapStyles = [{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"off"},{"lightness":"-100"},{"saturation":"-100"},{"gamma":"0.00"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40},{"visibility":"off"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"saturation":"67"},{"gamma":"5.81"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":17},{"visibility":"off"},{"hue":"#ff0000"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ff0000"},{"lightness":29},{"weight":0.2},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":19}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"lightness":"-2"}]},{"featureType":"transit.station.airport","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.airport","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"lightness":"71"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#177ea2"},{"lightness":17}]}];

function initMap(mapId, lat, long, link, zoomLevel) {
    const mapElement = document.getElementById(mapId);

    const markerImage = "/static/images/marker.png";
    const mapPopUpContent = `<div class="map-popup">
                                  <p><a href='${link}' target="_blank" rel="noopener noreferrer">
                                      Get directions with Google.</a>
                                  </p>
                              </div>`;

    const mapPosition = new google.maps.LatLng(lat, long);

    const mapOptions = {
        zoom: zoomLevel ? parseInt(zoomLevel, 10) : 16,
        minZoom: 6,
        maxZoom: 20,
        zoomControl:true,
        zoomControlOptions: {
            style:google.maps.ZoomControlStyle.TRUE
        },
        center: mapPosition,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        draggable: window.innerWidth > 900,
        scrollwheel: false,
        panControl:false,
        mapTypeControl:false,
        scaleControl:false,
        streetViewControl:false,
        overviewMapControl:false,
        rotateControl:false
        //styles: mapStyles
    };

    const mapInitialiser = function mapInitialiser() {

        const map = new google.maps.Map(mapElement, mapOptions);

        const image = new google.maps.MarkerImage(markerImage, null, null, null, new google.maps.Size(43,43));

        const marker = new google.maps.Marker({
            position: mapPosition,
            //icon:image,
            map: map
        });

        if (link) {
            const infowindow = new google.maps.InfoWindow({content: mapPopUpContent});

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(mapPosition);
        });

        // Listen out for a tab change event and trigger a resize on the map.
        document.addEventListener('tabChange', (e) => {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(mapPosition);
        });
    };

    return mapInitialiser;
}


function init(conf) {
    if (window.google) {
        google.maps.event.addDomListener(window, 'load', initMap(conf.mapId, conf.latitude, conf.longitude, conf.mapLink, conf.zoom));
    } else {

        let errorDiv;

        const noMapWrapper = document.getElementsByClassName('no-map-container');
        if (noMapWrapper) {
            errorDiv = noMapWrapper;
        } else {
            errorDiv = mapElement;
        }

        errorDiv.innerHTML = "<p class='u-text-center u-sentiment-error'>Google Maps API JS has not been loaded.</p>";
    }
}

export default { init }

